/**
 * @generated SignedSource<<d5ef904a2da89762021e5ca956ec0ed6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AttendeeStatus = "going" | "not_going" | "%future added value";
export type eventCardUnConfirmAttendanceMutation$variables = {
  club: string;
  slug: string;
};
export type eventCardUnConfirmAttendanceMutation$data = {
  readonly unconfirmPresence: {
    readonly attendee: {
      readonly status: AttendeeStatus;
    } | null | undefined;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"eventCard" | "eventFragment" | "eventSummaryFragment" | "portals_eventPortal">;
  };
};
export type eventCardUnConfirmAttendanceMutation = {
  response: eventCardUnConfirmAttendanceMutation$data;
  variables: eventCardUnConfirmAttendanceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "club"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v2 = [
  {
    "kind": "Variable",
    "name": "club",
    "variableName": "club"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Attendee",
  "kind": "LinkedField",
  "name": "attendee",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signedUrl",
    "storageKey": null
  },
  (v3/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageFile",
  "kind": "LinkedField",
  "name": "photo",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarFallback",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "eventCardUnConfirmAttendanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "unconfirmPresence",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "eventCard"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "eventSummaryFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "portals_eventPortal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "eventFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "eventCardUnConfirmAttendanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "unconfirmPresence",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eventUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timezone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "attendeeCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "address",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageFile",
            "kind": "LinkedField",
            "name": "coverPhoto",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "host",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 3
              }
            ],
            "concreteType": "AttendeeConnection",
            "kind": "LinkedField",
            "name": "attendees",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AttendeeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attendee",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v6/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "attendees(first:3)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c1766ae1c6a9cf8195716f0058a3c885",
    "id": null,
    "metadata": {},
    "name": "eventCardUnConfirmAttendanceMutation",
    "operationKind": "mutation",
    "text": "mutation eventCardUnConfirmAttendanceMutation(\n  $slug: String!\n  $club: String!\n) {\n  unconfirmPresence(club: $club, slug: $slug) {\n    id\n    attendee {\n      status\n    }\n    ...eventCard\n    ...eventSummaryFragment\n    ...portals_eventPortal\n    ...eventFragment\n  }\n}\n\nfragment eventCard on Event {\n  id\n  title\n  slug\n  startDate\n  endDate\n  eventUrl\n  timezone\n  attendeeCount\n  address\n  type\n  coverPhoto {\n    signedUrl\n    id\n  }\n  attendee {\n    status\n  }\n  host {\n    displayName\n    photo {\n      signedUrl\n      id\n    }\n    avatarFallback\n    id\n  }\n}\n\nfragment eventFragment on Event {\n  id\n  title\n  slug\n  description\n  startDate\n  endDate\n  eventUrl\n  timezone\n  attendeeCount\n  address\n  type\n  coverPhoto {\n    signedUrl\n    id\n  }\n  attendee {\n    status\n  }\n  host {\n    displayName\n    photo {\n      signedUrl\n      id\n    }\n    avatarFallback\n    id\n  }\n  ...eventSummaryFragment\n  ...eventSummary_dates\n  ...eventSummary_attendees\n  ...eventSummary_location\n  ...eventSummary_attendance\n}\n\nfragment eventSummaryFragment on Event {\n  attendee {\n    status\n  }\n  ...eventSummary_dates\n  ...eventSummary_attendees\n  ...eventSummary_location\n  ...eventSummary_attendance\n}\n\nfragment eventSummary_attendance on Event {\n  slug\n  attendee {\n    status\n  }\n  endDate\n}\n\nfragment eventSummary_attendees on Event {\n  attendeeCount\n  attendees(first: 3) {\n    edges {\n      node {\n        user {\n          avatarFallback\n          photo {\n            signedUrl\n            id\n          }\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      totalCount\n    }\n  }\n}\n\nfragment eventSummary_dates on Event {\n  startDate\n  endDate\n}\n\nfragment eventSummary_location on Event {\n  eventUrl\n  address\n  type\n}\n\nfragment portals_eventPortal on Event {\n  id\n  title\n  startDate\n  endDate\n  slug\n}\n"
  }
};
})();

(node as any).hash = "b221eab6ebe43003ebb3b1cfdc8f6cf5";

export default node;
